import { DateTime } from "luxon"
import qs from "qs"

const sortAlphabetically = (a: string, b: string) => {
  return a.localeCompare(b)
}

interface BuildUrlSearchParamsStringOptions {
  dateFormat: "yyyy" | "yyyy-MM-dd"
}

/**
 * Builds a URL search params string
 * @param newParams - The new params to add or update
 * @param currentParams - The current URL search params
 * @param options.dateFormat - The date format to use for any params that are dates
 * @returns The URL search params string
 * @example
 * buildUrlSearchParamsString(
 *  {
 *    year: dateRange.start,
 *  },
 *  searchParams,
 *  {
 *    dateFormat: "yyyy",
 *  })
 */
export const buildUrlSearchParamsString = (
  newParams: Record<string, unknown>,
  currentParams: URLSearchParams = new URLSearchParams(),
  { dateFormat }: BuildUrlSearchParamsStringOptions = {
    dateFormat: "yyyy-MM-dd",
  }
) =>
  qs.stringify(
    {
      ...Object.fromEntries(currentParams.entries()),
      ...newParams,
    },
    {
      filter: (prefix, value): string => {
        if (value instanceof DateTime) {
          return (value as DateTime).toFormat(dateFormat)
        }

        return value as string
      },
      sort: sortAlphabetically,
    }
  )
